import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { switchMap, take } from 'rxjs/operators';
import { combineLatest, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // Check if we're in local development mode
  const isLocalDev = !!(environment as any).isLocalDev || !(environment as any).auth?.enabled;

  console.log('🔍 Auth Interceptor - Request URL:', req.url);
  console.log('🔍 Auth Interceptor - Local dev mode:', isLocalDev);
  console.log('🔍 Auth Interceptor - Contains /api:', req.url.includes('/api'));
  console.log('🔍 Auth Interceptor - Contains /auth/:', req.url.includes('/auth/'));

  // Skip auth for non-API requests or requests to auth endpoints
  if (!req.url.includes('/api') || req.url.includes('/auth/')) {
    console.log('⏭️ Auth Interceptor - Skipping auth for:', req.url);
    return next(req);
  }

  console.log('🔐 Auth Interceptor - Adding auth for:', req.url);

  // In local development mode, use mock tokens
  if (isLocalDev) {
    console.log('🎭 Auth Interceptor - Using mock auth headers');
    const authReq = req.clone({
      headers: req.headers
        .set('Authorization', 'Bearer mock-access-token-local-dev')
        .set('X-ID-Token', 'mock-id-token-local-dev')
        .set('X-Dev-Mode', 'true'),
    });
    return next(authReq);
  }

  // Production mode - get real tokens
  return combineLatest([authService.getAccessToken(), authService.getIdToken()]).pipe(
    take(1),
    switchMap(([accessToken, idToken]) => {
      console.log('🎫 Auth Interceptor - Access Token received:', accessToken ? 'YES' : 'NO');
      console.log('🎫 Auth Interceptor - ID Token received:', idToken ? 'YES' : 'NO');

      if (accessToken) {
        let authReq = req.clone({
          headers: req.headers.set('Authorization', `Bearer ${accessToken}`),
        });

        // Add ID token if available
        if (idToken) {
          authReq = authReq.clone({
            headers: authReq.headers.set('X-ID-Token', idToken),
          });
          console.log('✅ Auth Interceptor - Both Authorization and X-ID-Token headers added');
        } else {
          console.log('✅ Auth Interceptor - Only Authorization header added');
        }

        return next(authReq);
      }

      console.log('❌ Auth Interceptor - No access token available');
      return next(req);
    })
  );
};
